/* WBG global storefront behaviour */

(function () {
  function initWbgProductCards() {
    if (!window.matchMedia('(max-width: 768px)').matches) return;

    let openCard = null;

    document.querySelectorAll('[data-wbg-card]').forEach(function (card) {
      const imageWrap = card.querySelector('[data-wbg-image]');
      if (!imageWrap || imageWrap.dataset.wbgTapInitialised === 'true') return;

      imageWrap.dataset.wbgTapInitialised = 'true';

      imageWrap.addEventListener('click', function (event) {
        event.preventDefault();

        if (card.classList.contains('show-overlay')) {
          card.classList.remove('show-overlay');
          openCard = null;
          return;
        }

        if (openCard && openCard !== card) {
          openCard.classList.remove('show-overlay');
        }

        card.classList.add('show-overlay');
        openCard = card;
      });
    });

    document.addEventListener(
      'click',
      function (event) {
        if (!openCard) return;
        const clickedInside = event.target.closest('[data-wbg-card]');
        if (clickedInside === openCard) return;
        openCard.classList.remove('show-overlay');
        openCard = null;
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWbgProductCards);
  } else {
    initWbgProductCards();
  }

  document.addEventListener('shopify:section:load', initWbgProductCards);
})();
